<template lang="pug">
  .component-policy
    .inner-content(v-if="$is('listing')")
      .row
        .columns.large-1
          .field {{item.recipient_id}}
          router-link(:to="{name:item.recipient_type.toLowerCase(), params:{id:item.recipient_id}}")
            .field
              a.fa.fa-user-circle-o(v-if="item.recipient_type === 'Client'")
              a.fa.fa-drivers-license-o(v-if="item.recipient_type === 'Driver'")
        .columns.large-4
          .field {{item.type}}
          .field sent at: {{item.date}}
        .columns.large-7
          .field {{getStrippedMessage()}}
            ModalReveal
              a(slot="trigger") show all
              .row(v-for=" (im,k) in item.message")
                .columns(class="flex0") {{k}}:
                .columns {{im}}
</template>

<script>

  import ModalReveal from "../structure/foundation/ModalReveal";

  export default {
    name: 'Notification',
    components: {ModalReveal},
    props: ['item', 'type'],
    data: function () {
      return {
        strippedMessage: ''
      }
    },
    methods: {
      getStrippedMessage() {

        if (this.item.message.subject) {
          this.strippedMessage = this.item.message.subject
        } else {
          this.strippedMessage = JSON.stringify(this.item.message).slice(0, 160)
        }
        return this.strippedMessage
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .flex0
    flex: 0 0 30%

</style>



// WEBPACK FOOTER //
// Notification.vue?76e67ab0